import { FC, PropsWithChildren } from 'react'

import { Icon, IconProps } from '@trustycars/genie-ui/icons/Icon'

import { TagsNoRef } from '@trustycars/genie-ui/types'
import { propsWithClassNames } from '@trustycars/genie-ui/functions'

import { container, ContainerVariants, content } from './style.css'

export type StatusMessageProps = {
  icon?: IconProps['namespace'] | null
  containerProps?: TagsNoRef<'header'>
} & ContainerVariants

export const StatusMessage: FC<PropsWithChildren<StatusMessageProps>> = ({
  children,
  icon = 'Warning',
  containerProps,
  ...containerVariants
}) => (
  <header
    role="status"
    {...propsWithClassNames(containerProps, container(containerVariants))}
  >
    {icon && <Icon namespace={icon} />}
    {children && <div className={content} children={children} />}
  </header>
)

export default StatusMessage
